<template>
  <span>{{ showText }}</span>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
    }
  },
  computed: {
    showText() {
      let text = 'A'
      if (this.index === 1) text = 'A'
      if (this.index === 2) text = 'B'
      if (this.index === 3) text = 'C'
      if (this.index === 4) text = 'D'
      return text
    },
  },
}
</script>

<style lang="scss">
</style>
